/* eslint-disable */
export default {
  attachFiles: 'Liitä tiedosto',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
